//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";
import { service, nativeApi } from "@/common/index";
import { syncResponsibilitySession } from "@/utils/responsibilityUtils";
import { Dialog, Icon } from "vant";

export default {
  data() {
    return {
      showRespPicker: false,
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      responsibilityId: (state) => state.user.responsibilityId,
      languageCode: (state) => state.user.languageCode,
    }),
    responsibility: {
      get() {
        if (this.userInfo == null) {
          return "";
        }
        const role = this.userInfo.userRespList.find(
          (item) => item.responsibilityId === this.responsibilityId
        );
        return role != null ? role.responsibilityName : "";
      },
      set(val) {},
    },
    respActions() {
      const userRespList = (this.userInfo && this.userInfo.userRespList) || [];
      const mobileList = userRespList.filter(
        (item) => item.systemCode === "MOBILE"
      );
      const respList = mobileList.length ? mobileList : userRespList;
      return respList.map((item) => ({
        name: item.responsibilityName,
        responsibilityId: item.responsibilityId,
      }));
    },
  },
  created() {},
  activated: function () {},
  methods: {
    initResp() {
      // 职责列表由 computed respActions 实时从 userInfo 计算
    },
    changeResp() {
      if (!this.respActions.length) {
        Dialog.alert({ message: "暂无可用职责" });
        return;
      }
      this.showRespPicker = true;
    },
    async onSelectResp(action) {
      if (!action || action.responsibilityId == null) return;
      if (action.responsibilityId === this.responsibilityId) return;

      const toast = this.$toast.loading({
        message: "切换中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        const result = await syncResponsibilitySession(
          this.$store,
          action.responsibilityId,
          this.languageCode
        );
        toast.clear();
        if (!result.success) {
          Dialog.alert({ message: result.message || "切换职责失败" });
        }
      } catch (err) {
        toast.clear();
        Dialog.alert({ message: "切换职责失败，请重试" });
      }
    },
    /**扫一扫*/
    doScan() {
      alert("扫一扫")
    },
  },
  watch: {},
  mounted() {
    this.initResp()
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/home/UserHeader.vue